var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-b-50"},[_c('p',{staticClass:"font-weight-bold text-capitalize"},[_vm._v(" "+_vm._s(_vm.item.title)+" ")]),_vm._l((_vm.item.context),function(p,i){return _c('p',{key:i},[_vm._v(" "+_vm._s(p)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }